import axios from './request'


//登录
export const login = (params)=> axios.post("/login",params);
//退出登录
export const logout = (params)=> axios.delete("/ems/logout",params);
//个人信息
export const getUserInfo = (params)=> axios.get("/userinfo",{params});
//修改个人信息
export const updateUserInfo = (params)=> axios.put("/userinfo",params);

//修改密码
export const updateUserPassword = (params)=> axios.put("/userinfo/password",params);

//获取微信手机号
export const getWxPhone = (params)=> request.postForm(`/wx/ma/phoneNumber`,params);

//手机号登陆
export const PhoneLogin = (params)=> axios.post("/userinfo/login_password",params);

//微信登陆
export const wxLogin = (params)=> axios.post("/wx/ma/login",params);

export const wxPhoneLogin = (params)=> axios.post("/wx/ma/phone_login",params);

export const wxPhoneNumber = (params)=> axios.get("/wx/ma/phoneNumber",params);
